import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from 'react';
import { motion } from 'framer-motion';
import clsx from 'clsx';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import NetworkTabIcon from '../../../../components/Icons/NetworkTabIcon';
import ExchangeTabIcon from '../../../../components/Icons/ExchangeTabIcon';
import DepositTabIcon from '../../../../components/Icons/DepositTabIcon';
import AppSettings from '../../../../lib/AppSettings';
const TabsContext = createContext(undefined);
export const useTabs = () => {
    const ctx = useContext(TabsContext);
    if (!ctx)
        throw new Error('useTabs must be used within <Tabs>');
    return ctx;
};
export const Tabs = ({ defaultValue, children }) => {
    const [activeId, setActiveId] = useState(defaultValue);
    return (_jsx(TabsContext.Provider, { value: { activeId, setActiveId }, children: children }));
};
export const TabsList = ({ children }) => {
    const { isDesktop } = useWindowDimensions();
    const [hovered, setHovered] = useState(false);
    const hoveredOnDesktop = isDesktop && hovered && AppSettings.ThemeData?.enableWideVersion == true;
    return (_jsx("div", { className: "relative", children: _jsx(motion.div, { onHoverStart: () => setHovered(true), onHoverEnd: () => setHovered(false), animate: { width: AppSettings.ThemeData?.enableWideVersion == true ? hoveredOnDesktop ? 180 : isDesktop ? 48 : 'auto' : 'auto' }, className: clsx("overflow-hidden rounded-lg", { 'sm:!absolute sm:!rounded-l-xl sm:!rounded-r-none sm:!top-24 sm:!right-full': AppSettings.ThemeData?.enableWideVersion == true }), transition: { type: 'spring', bounce: 0.2, duration: 0.6 }, children: _jsx("div", { className: clsx("bg-secondary-500 h-full p-1.5 w-full flex flex-row space-y-0 space-x-2", { 'sm:!flex-col sm:!p-2 sm:!space-y-2 sm:!space-x-0': AppSettings.ThemeData?.enableWideVersion == true }), children: React.Children.map(children, child => React.isValidElement(child)
                    ? React.cloneElement(child, { isHovered: hoveredOnDesktop })
                    : child) }) }) }));
};
export const TabsTrigger = ({ value, isHovered, label, Icon }) => {
    const ctx = useContext(TabsContext);
    if (!ctx)
        throw new Error('TabsTrigger must be used within <Tabs>');
    const isActive = ctx.activeId === value;
    return (_jsxs("button", { type: "button", "aria-label": label, onClick: () => ctx.setActiveId(value), className: clsx('w-full flex items-center justify-start p-1! hover:bg-secondary-100 text-secondary-text hover:text-primary-text overflow-hidden rounded-md max-sm:justify-center max-sm:px-0 gap-1.5', {
            'bg-secondary-300 !text-primary-text': isActive,
            'sm:p-0.5!': AppSettings.ThemeData?.enableWideVersion == false
        }), children: [_jsx("div", { className: clsx("h-5 w-5", { 'sm:!h-6 sm:!w-6': AppSettings.ThemeData?.enableWideVersion == true }), children: _jsx(Icon, { className: clsx('h-5 w-5', { 'sm:!h-6 sm:!w-6': AppSettings.ThemeData?.enableWideVersion == true }) }) }), isHovered && _jsx("span", { className: "text-sm whitespace-nowrap", children: label })] }));
};
export const TabsContent = ({ value, children }) => {
    const ctx = useContext(TabsContext);
    if (!ctx)
        throw new Error('TabsContent must be used within <Tabs>');
    return _jsx(_Fragment, { children: value === ctx.activeId && (_jsx(_Fragment, { children: children })) });
};
export const NetworkExchangeTabs = () => {
    return _jsxs(TabsList, { children: [_jsx(TabsTrigger, { label: "Swap", Icon: NetworkTabIcon, value: "cross-chain" }), _jsx(TabsTrigger, { label: "Deposit from CEX", Icon: ExchangeTabIcon, value: "exchange" }), _jsx(TabsTrigger, { label: "Easy deposit", Icon: DepositTabIcon, value: "deposit-address" })] });
};
